import { Index as BranchReport} from "./branchReport/Index"
import { Index as SalesEntryReport } from "./salesReportEntry/Index"
import { useContext, useEffect } from "react"
import { ToolContext } from "../../../../core/context/ToolContext"
import { Box } from "@mui/material"
import { useHistory } from "react-router-dom/cjs/react-router-dom"

const Component =({role, match, nav})=>{
    if(role === "Regular User"){
        return <SalesEntryReport/>
    }else{
        return <BranchReport match={match}/>
    }
}

export const Index = ({match}) =>{
    const nav = useHistory()

    const {tool_state} = useContext(ToolContext)
    const {__SESSION} = tool_state

    const role = __SESSION.data.uaccess[0].role_name

    useEffect(() => {
        role !== "Regular User" &&  nav.push('/reports/branch-product')
        //eslint-disable-next-line
    }, []);


    return(
        <Box sx={{height: "100%"}}>
            <Component role={role} match={match} nav={nav}/>
        </Box>
    )
}